import { render } from "./EncounterView.vue?vue&type=template&id=318291f5&ts=true"
import script from "./EncounterView.vue?vue&type=script&lang=ts"
export * from "./EncounterView.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/armieisla/workspace/charmedteq/icare/icare-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__